var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOutDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1953 4.19526C10.4556 3.93491 10.8777 3.93491 11.1381 4.19526L14.4714 7.5286C14.7318 7.78894 14.7318 8.21106 14.4714 8.4714L11.1381 11.8047C10.8777 12.0651 10.4556 12.0651 10.1953 11.8047C9.93491 11.5444 9.93491 11.1223 10.1953 10.8619L13.0572 8L10.1953 5.13807C9.93491 4.87772 9.93491 4.45561 10.1953 4.19526Z",
    fill: "#2C303B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 7.99998C5.33325 7.63179 5.63173 7.33331 5.99992 7.33331H13.9999C14.3681 7.33331 14.6666 7.63179 14.6666 7.99998C14.6666 8.36817 14.3681 8.66665 13.9999 8.66665H5.99992C5.63173 8.66665 5.33325 8.36817 5.33325 7.99998Z",
    fill: "#2C303B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 2.66665C3.15644 2.66665 2.98687 2.73688 2.86185 2.86191C2.73682 2.98693 2.66659 3.1565 2.66659 3.33331V12.6666C2.66659 12.8435 2.73682 13.013 2.86185 13.138C2.98687 13.2631 3.15644 13.3333 3.33325 13.3333H5.99992C6.36811 13.3333 6.66659 13.6318 6.66659 14C6.66659 14.3682 6.36811 14.6666 5.99992 14.6666H3.33325C2.80282 14.6666 2.29411 14.4559 1.91904 14.0809C1.54397 13.7058 1.33325 13.1971 1.33325 12.6666V3.33331C1.33325 2.80288 1.54397 2.29417 1.91904 1.9191C2.29411 1.54403 2.80282 1.33331 3.33325 1.33331H5.99992C6.36811 1.33331 6.66659 1.63179 6.66659 1.99998C6.66659 2.36817 6.36811 2.66665 5.99992 2.66665H3.33325Z",
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutDark);
export default __webpack_public_path__ + "static/media/log-out-dark.a121f14bb1a6b049f7602c89af479bb8.svg";
export { ForwardRef as ReactComponent };